import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { ExportActivitiesQuantityPerStudentUseCaseInterface } from 'domain/usecases';

export class RemoteExportActivitiesQuantityPerStudent
  implements ExportActivitiesQuantityPerStudentUseCaseInterface
{
  constructor(
    private readonly pdfUrl: string,
    private readonly excelUrl: string,
    private readonly httpClient: HttpClient<ExportActivitiesQuantityPerStudentUseCaseInterface.Result>,
  ) {}

  async execute(
    params: ExportActivitiesQuantityPerStudentUseCaseInterface.Params,
  ): Promise<ExportActivitiesQuantityPerStudentUseCaseInterface.Result> {
    const { type, ...restParams } = params;
    const requestUrl = generateUrl(
      type === 'pdf' ? this.pdfUrl : this.excelUrl,
      restParams,
    );

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
      responseType: 'json',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
